import React, { useState, useEffect } from 'react';
import { sessionManager } from '../utils/sessionManager';
import { authService } from '../services/authService';

interface SessionDebugProps {
  show?: boolean;
}

const SessionDebug: React.FC<SessionDebugProps> = ({ show = false }) => {
  const [sessionInfo, setSessionInfo] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    if (!isVisible) return;

    const updateSessionInfo = () => {
      const info = {
        tabId: sessionManager.getTabId(),
        sessionState: sessionManager.getSessionInfo(),
        isCurrentTabActive: sessionManager.isCurrentTabActive(),
        isSessionActiveInOtherTabs: sessionManager.isSessionActiveInOtherTabs(),
        isAuthenticated: authService.isAuthenticated(),
        usuario: authService.getUsuario(),
        timestamp: new Date().toLocaleTimeString(),
        sessionStorage: {
          token: !!sessionStorage.getItem('token'),
          user: !!sessionStorage.getItem('user'),
          empresa: !!sessionStorage.getItem('empresa')
        },
        localStorage: {
          logoutTimestamp: localStorage.getItem('logout_timestamp'),
          activeTabs: localStorage.getItem('session_active_tabs'),
          sessionState: localStorage.getItem('session_state')
        }
      };
      setSessionInfo(info);
    };

    // Atualizar imediatamente
    updateSessionInfo();

    // Atualizar a cada 5 segundos
    const interval = setInterval(updateSessionInfo, 5000);

    return () => clearInterval(interval);
  }, [isVisible]);

  // Só mostrar em desenvolvimento
  if (process.env.NODE_ENV !== 'development' || !isVisible) {
    return null;
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        background: 'rgba(0,0,0,0.8)',
        color: 'white',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        zIndex: 9999,
        maxWidth: '400px',
        maxHeight: '500px',
        overflow: 'auto'
      }}
    >
      <div style={{ marginBottom: '10px' }}>
        <strong>Session Debug</strong>
        <button 
          onClick={() => setIsVisible(false)}
          style={{ 
            float: 'right', 
            background: 'red', 
            border: 'none', 
            color: 'white',
            borderRadius: '3px',
            padding: '2px 6px'
          }}
        >
          ×
        </button>
      </div>
      
      {sessionInfo && (
        <pre style={{ 
          fontSize: '10px', 
          lineHeight: '1.2',
          margin: 0,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}>
          {JSON.stringify(sessionInfo, null, 2)}
        </pre>
      )}
    </div>
  );
};

// Hook para mostrar/ocultar o debug
export const useSessionDebug = () => {
  const [showDebug, setShowDebug] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Ctrl + Shift + D para mostrar/ocultar debug
      if (event.ctrlKey && event.shiftKey && event.key === 'D') {
        event.preventDefault();
        setShowDebug(prev => !prev);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return { showDebug, setShowDebug };
};

export default SessionDebug;
